export interface Range {
  min: number
  max: number
}
